export default __webpack_public_path__ + "static/media/doorDeliveryIcon.925c0e8d.png";